export const PRODUCT_TAG = {
    BASE_PATH: '/product/product-tag/',
    GET_ALL: '/product-tag',
    CREATE: '/product-tag/create',
    UPDATE: '/product-tag/update/',
    DELETE: '/product-tag/delete/',
    ADD_NEW_TITLE: 'Add New Product Group',
};
